<template>
  <v-layout row wrap align-center>
    <v-flex xs12>
      <div>
        <v-card elevation="1">
          <v-form v-model="valid" ref="form">
            <v-tabs centered grow v-model="active" slider-color="primary">
              <template v-if="(isAdmin || isApplicant)">
                <v-tab>Health Care Provider info</v-tab>
                <v-tab-item>
                  <healthCare-Providerinfo
                    :HealthCareProvider="application.HealthCareProvider"
                    :Applications="application"
                    :disableFields="disableFields"
                  ></healthCare-Providerinfo>
                </v-tab-item>
                <v-tab>Licensure Information</v-tab>
                <v-tab-item>
                  <licensure-Information
                    :Licensure="application.Licensure"
                    :disableFields="disableFields"
                  ></licensure-Information>
                </v-tab-item>
                <v-tab>Education</v-tab>
                <v-tab-item>
                  <education
                    :Education="application.Education"
                    :disableFields="disableFields"
                  ></education>
                  <Apprentice-ship
                    :Apprenticeship="application.Apprenticeship"
                    :disableFields="disableFields"
                  ></Apprentice-ship>
                </v-tab-item>
                <v-tab>General Questions</v-tab>
                <v-tab-item>
                  <General-Questions
                    :GeneralQuestions="application.GeneralQuestion"
                    :disableFields="disableFields"
                  ></General-Questions>
                </v-tab-item>
                <v-tab>Loan and Lender Information</v-tab>
                <v-tab-item>
                  <lender-loan-info
                    :LenderLoanInfo="application.LenderLoanInfo"
                    :disableFields="disableFields"
                    v-on:updateTotal="updateTotal"
                  ></lender-loan-info>
                </v-tab-item>
              </template>

              <v-tab>Practice Site Information</v-tab>
              <v-tab-item>
                <PracticeSite-Information
                  :PracticeSiteInformation="application.PracticeSiteInformation"
                  :PracticeSite="application.PracticeSite"
                  :disableFields="disableFields"
                ></PracticeSite-Information>
              </v-tab-item>
              <v-tab>Employment Form</v-tab>
              <v-tab-item>
                <Employment-form
                  :Employment="application.Employment"
                  :disableFields="disableFields"
                ></Employment-form>
              </v-tab-item>
              <template v-if="isAdmin || isApplicant">
                <v-tab>Additional Documents</v-tab>
                <v-tab-item>
                  <additional-docs
                    :ApplicationDocuments="application.ApplicationDocuments"
                    :app_id="application.Id"
                  ></additional-docs>
                </v-tab-item>
                <v-tab>Print Application</v-tab>
                <v-tab-item>
                  <print-win :app="application" v-if="application.Id > 0" ref="print"></print-win>
                  <v-btn
                    color="primary"
                    class="floating--btn"
                    @click="printApplication"
                    >Print Application</v-btn
                  >
                </v-tab-item>
                <v-tab>Acknowledgments and Signatures</v-tab>
                <v-tab-item>
                  <Acknowledge-Signature
                    :Status="application.Status"
                    :CurrentStatus="application.CurrentStatus"
                    :disableFields="disableFields"
                    v-on:submit="submitApplication"
                  ></Acknowledge-Signature>
                </v-tab-item>
              </template>
              <v-tab>Verification</v-tab>
              <v-tab-item>
                <Signature
                  :Applications="application"
                  :Status="application.Status"
                  :disableFields="disableFields"
                  v-on:signoff="signOffApplication"
                ></Signature>
              </v-tab-item>
            </v-tabs>
          </v-form>

          <v-card-actions
            class="justify-center pb-4"
            v-if="
              isAdmin ||
                (isApplicant &&
                  (application.CurrentStatus === undefined ||
                    application.CurrentStatus.Status.Description == 'New'))
            "
          >
            <v-btn
              color="primary"
              class="floating--btn"
              @click="saveApplication"
              >Save Application</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>
    </v-flex>
    <v-snackbar v-model="snackbar" bottom left>
      <span>{{ errorText }}</span>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="850px" v-if="dialog">
      <v-card>
        <v-card-title>Site Facilitators</v-card-title>
        <v-card-text>
          <template v-if="facilitators.length > 0">
            WySLRP found the following registered site facilitators for your
            primary practice site,
            {{ primarySite.SiteAddress.SiteInsitutionName }}. If you do not see
            your site facilitator on this please contact your site facilitator
            and ask them to register. If your site facilitator is listed as
            having an inactive account please contact the WySLRP site
            administrator.
            <div
              v-for="f in facilitators"
              :key="f.ID"
              style="text-align:left"
              :class="userClass(f.User)"
            >
              <strong>{{ f.User.FirstName }} {{ f.User.LastName }}</strong>
              <v-divider></v-divider>
              {{ f.User.UserName }} (
              <template v-if="f.User.IsActive">Active</template>
              <template v-else>Inactive</template>)
              <br />
              <br />
            </div>
          </template>
          <template v-else
            >WySLRP does not currently have any site facilitators registered for
            your primary practice site,
            {{ primarySite.SiteAddress.SiteInsitutionName }}. Please contact
            your site facilitator and ask them to register.</template
          >
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="
              dialog = false
              facilitators = []
              primarySite = {}
            "
            >close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import appConfig from '@src/app.config'
import healthCareProviderinfo from '../../components/AppHealthCareProviderInfo'
import licensureInformation from '../../components/AppLicensureInformation'
import Education from '../../components/AppEducation'
import Apprenticeship from '../../components/AppApprenticeship'
import generalQuestions from '../../components/AppGeneralQuestions'
import PracticeSiteInformation from '../../components/AppPracticeSiteInformation'
import EmploymentForm from '../../components/AppPracticeSiteAppEmpVForm'
import AcknowledgeAndSignature from '../../components/AppAcknowledgeAndSignature'
import Signature from '../../components/AdminSignature'
import { authComputed } from '@state/helpers'
import LenderAndLoanInfoVue from '../../components/LenderAndLoanInfo.vue'
import moment from 'moment'
import AdditionalDocumentsVue from '../../components/AdditionalDocuments/AdditionalDocuments.vue'
import PrintWindowVue from '../../components/PrintWindow.vue'
const moduleNamespace = 'application'
export default {
  page: {
    title: 'Application',
  },
  name: 'Application',
  data() {
    return {
      active: 0,
      application: {
        Id:0,
        HealthCareProvider: {
          Address: {},
          ProfessionAndSpecialty: {},
          RaceEthinicity: {},
          Languages: [],
        },
        Licensure: {},
        Education: [
          { SchoolType: 'Undergraduate' },
          { SchoolType: 'Graduate' },
        ],
        Apprenticeship: [
          { ApprenticeshipSiteType: 'Residency' },
          { ApprenticeshipSiteType: 'Internship' },
          { ApprenticeshipSiteType: 'Preceptorship' },
        ],
        GeneralQuestion: {},
        PracticeSite: {},
        PracticeSiteInformation: [
          {
            SiteAddress: {},
          },
        ],
        LenderLoanInfo: [{}],
        Employment: {
          RecruitmentwithinLastThreeMonths: false,
          RetentionExistingStaff: false,
        },
        Status: [],
      },
      snackbar: false,
      errorText: '',
      facilitators: [],
      primarySite: {},
      dialog: false,
      valid: true,
    }
  },
  created() {
    if (this.$route.params.id > 0) {
      this.loadApp(this.$route.params.id)
    }
  },
  methods: {
    saveApplication() {
      //debugger

      this.application.LenderLoanInfo.forEach((i) => {
        if (
          !!i &&
          !!i.InterestRate &&
          i.InterestRate.toString().includes('%')
        ) {
          i.InterestRate = i.InterestRate.substring(
            0,
            i.InterestRate.length - 1
          )
        }
      })
      axios
        .post('/Applications/Save', this.application)
        .then((response) => {
          this.application = response.data
          this.application.LenderLoanInfo.forEach((i) => {
            if (
              !!i &&
              !!i.InterestRate &&
              !i.InterestRate.toString().includes('%')
            ) {
              i.InterestRate = `${i.InterestRate}%`
            }
          })
          this.errorText = 'Application Saved Successfully'
          this.snackbar = true
        })
        .catch((error) => {
          console.log(error.response.data)
          this.errorText = error.response.data
          this.snackbar = true
        })
    },
    submitApplication() {
      let x = this.$refs.form.validate()
      if (x) {
        this.application.LenderLoanInfo.forEach((i) => {
          if (
            !!i &&
            !!i.InterestRate &&
            i.InterestRate.toString().includes('%')
          ) {
            i.InterestRate = i.InterestRate.substring(
              0,
              i.InterestRate.length - 1
            )
          }
        })
        let hasSF = false,
          hasJD = false,
          hasEC = false,
          hasPL = false,
          hasPoC = false
        if (this.application.Licensure.AreyouCurrentlyLicensedinWy == false) {
          hasPL = true
        }
        this.application.ApplicationDocuments.forEach((d) => {
          if (!!d && d.Type == 'SlidingFeeSchedule') hasSF = true
          else if (d.Type == 'JobDescription') hasJD = true
          else if (d.Type == 'EmployeeContract') hasEC = true
          else if (d.Type == 'ProfessionalLicense') hasPL = true
          else if (d.Type == 'ProofOfCitizenship') hasPoC = true
        })
        if (hasSF && hasJD && hasEC && hasPL && hasPoC) {
          axios
            .post(`/Applications/Submit`, this.application)
            .then((response) => {
              this.application = response.data
              this.application.LenderLoanInfo.forEach((i) => {
                if (
                  !!i &&
                  !!i.InterestRate &&
                  !i.InterestRate.toString().includes('%')
                ) {
                  i.InterestRate = `${i.InterestRate}%`
                }
              })
              this.getFacilitators()
            })
            .catch((error) => {
              console.log(error.response.data)
              this.errorText = error.response.data
              this.snackbar = true
            })
        } else {
          this.errorText =
            'Error occurred while uploading documents, Please upload documents again before submitting your application'
          this.snackbar = true
        }
      } else {
        this.errorText =
          'You are missing some required information, please review your application and submit again'
        this.snackbar = true
      }
    },
    signOffApplication() {
      this.application.LenderLoanInfo.forEach((i) => {
        if (
          !!i &&
          !!i.InterestRate &&
          i.InterestRate.toString().includes('%')
        ) {
          i.InterestRate = i.InterestRate.substring(
            0,
            i.InterestRate.length - 1
          )
        }
      })
      axios
        .get(
          `/Applications/SignOff/${this.application.Id}?d=${this.application.HCBeginWorkDateConfirmfacilitator}`
        )
        .then((response) => {
          this.application = response.data
          this.application.LenderLoanInfo.forEach((i) => {
            if (
              !!i &&
              !!i.InterestRate &&
              !i.InterestRate.toString().includes('%')
            ) {
              i.InterestRate = `${i.InterestRate}%`
            }
          })
          this.errorText = 'Application Successfully Verified'
          this.snackbar = true
        })
        .catch((error) => {
          console.log(error.response.data)
          this.errorText = error.response.data
          this.snackbar = true
        })
    },
    loadApp(id) {
      axios
        .get(`/Applications/${id}`)
        .then((response) => {
          this.application = response.data
          this.application.LenderLoanInfo.forEach((i) => {
            if (
              !!i &&
              !!i.InterestRate &&
              !i.InterestRate.toString().includes('%')
            ) {
              i.InterestRate = `${i.InterestRate}%`
            }
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },
    getFacilitators() {
      axios
        .get(`Users_Sites/Facilitator?appID=${this.application.Id}`)
        .then((response) => {
          this.facilitators = response.data.facilitators
          this.primarySite = response.data.site
          this.dialog = true
        })
        .catch((err) => {
          console.log(err.response.data)
        })
    },
    userClass(u) {
      if (!u.IsActive) {
        return 'inactive-user'
      }
      return ''
    },
    updateTotal(val) {
      this.application.TotalEligibleDebtSeekingAssistThroughWYSLRP = val
    },
    printApplication() {
      this.$refs.print.openDialog()
    },
  },
  computed: {
    ...authComputed,
    disableFields() {
      if (this.isAdmin) {
        //admins can always edit
        return false
      }
      if (this.isFacilitator) {
        //facilitators cannot edit
        return true
      }
      //applicants can edit if it has not been approved
      if (
        this.application.CurrentStatus &&
        this.application.CurrentStatus.Status.Description != 'New' &&
        this.application.CurrentStatus.Status.Description != 'Submitted'
      ) {
        return true
      }
      return false
    },
  },
  components: {
    'healthCare-Providerinfo': healthCareProviderinfo,
    'licensure-Information': licensureInformation,
    education: Education,
    'Apprentice-ship': Apprenticeship,
    'General-Questions': generalQuestions,
    'PracticeSite-Information': PracticeSiteInformation,
    'lender-loan-info': LenderAndLoanInfoVue,
    'Employment-form': EmploymentForm,
    'Acknowledge-Signature': AcknowledgeAndSignature,
    'additional-docs': AdditionalDocumentsVue,
    Signature: Signature,
    'print-win': PrintWindowVue,
  },
}
</script>
<style>
.inactive-user {
  color: gray;
}
.v-messages__message {
  color: red !important;
}
</style>
